<template>
  <div v-if='data.length > 0'>
    <div class='company-sidebar__title'>
      <h2>Documentation</h2>
      <a href='#' v-if='!hideEmpty' @click.prevent.stop='toggleEmpty'><i class='fas fa-eye-slash'></i>Hide Blank</a>
      <a href='#' v-if='hideEmpty' @click.prevent.stop='toggleEmpty'><i class='fas fa-eye'></i>Show All</a>
    </div>
    <div href='#' v-for='folder in folders' class='company-sidebar__folder'>
      <a href='#' class='company-sidebar__folder__a' @click.prevent.stop='toggleFolder(folder.id)'>
        <div class='asset-icon'>
          <i v-if='activeFolderId == folder.id' class='fas fa-caret-down'></i>
          <i v-if='activeFolderId != folder.id' class='fas fa-caret-right'></i>
        </div>
        <span class="company-sidebar__name">{{folder.name }}</span>
      </a>
      <a :href="d.url" v-if='activeFolderId == folder.id' v-for='(d, index) in filteredFolderData' :class='{"selected": d.selected, "company-sidebar__folder-item": true, "company-sidebar__a": true}'>
        <div class="asset-icon" :style="{background: d.color}">
          <i :class="d.icon" :style="{color: d.icon_color}"></i>
        </div>
        <span class="company-sidebar__name">{{d.name}}</span>
        <span class="count">{{d.count}}</span>
      </a>
    </div>
    
    <a class='company-sidebar__a' :href="d.url" v-if='!d.sidebar_folder_id' v-for='(d, index) in filteredData' :class='{"selected": d.selected}'>
      <div class="asset-icon" :style="{background: d.color}">
        <i :class="d.icon" :style="{color: d.icon_color}"></i>
      </div>
      <span class="company-sidebar__name">{{d.name}}</span>
      <span class="count">{{d.count}}</span>
    </a>
  </div>
</template>

<script>
export default {
  props: ["data", "folders", "selected_folder"],
  data () {
    return {
      hideEmpty: false,
      activeFolderId: this.selected_folder
    }        
  },
  mounted () {
    if (localStorage.getItem('huduHideEmptySidebarAssets')) {
      try {
        this.hideEmpty = true;
      } catch(e) {
        
      }
    }
  },
  methods: {
    toggleFolder(id) {
      if(this.activeFolderId == id) {
        this.activeFolderId = 0;
      } else {
        this.activeFolderId = id;
      }
    },
    toggleEmpty () {
      this.hideEmpty = !this.hideEmpty;

      if (this.hideEmpty === true) {
        localStorage.hide_assets = true
        localStorage.setItem('huduHideEmptySidebarAssets', true);
      } else {
        localStorage.removeItem('huduHideEmptySidebarAssets')
      }
      
      // if (this.hideEmpty === true) {
        
      //   localStorage.setItem('huduHideEmptySidebarAssets', false);
      // } else {
      //   this.hideEmpty = true;
      //   localStorage.setItem('huduHideEmptySidebarAssets', true);
      // }
    }
  },
  computed: {
    filteredData() {
      return this.hideEmpty ? this.data.filter(item => !(item.count == 0)) : this.data
    },
    filteredFolderData() {
      return this.filteredData.filter(item => item.sidebar_folder_id == this.activeFolderId)
    }
  }
}
</script>